// // RoiInvestorBenefits.tsx
// /* eslint-disable @next/next/no-img-element */
// import * as React from "react";
// import { Box, Paper, Stack, Typography, Grid, Divider } from "@mui/material";
// import Heading from "../../heading";
// import BlogListItem from "./BlogList";

// const MAX_W = 1300;     // section content cap
// const IMG_W = 1200;      // max width for the illustration

// export default function RoiInvestorBenefits({ data, onClick, buttonMarginTop }) {
//     console.log("data", data);

//     const {
//         title = "Latest Insights",
//         subtitle = "Read the latest design and tech stories",
//         showSparkle,
//         bgcolor,
//     } = data || {};

//     // Adapted listData from your API response
//     const listData = Array.isArray(data)
//         ? data.map((item) => ({
//               id: item._id,
//               href: `/blogs/${item._id}`,
//               imageSrc: `${process.env.IMAGE_BASE_URL}/${item.image_url}`,
//               category: item.tags?.[0] ?? "BLOG",
//               title: item.title,
//               excerpt: item.sub_title,
//               author: item.posted_by_name,
//               date: item.posted_at_formated,
//               profileImage: item.posted_by_profile_image,
//           }))
//         : [];

//     return (
//         <Box
//             component="section"
//             sx={{
//                 py: { xs: 8, md: 4 },
//                 px: { xs: 2, sm: 3 },
//                 bgcolor: bgcolor ?? "#fffff",
//             }}
//         >
//             {/* Header */}
// <Heading
//     title={title}
//     subtitle={subtitle}
//     lineClamp={showSparkle ? 2 : 1}
//     showSparkle={showSparkle ? "/img/investments/Sparkle.svg" : undefined}
//     mb={7}
// />

//             <Stack spacing={5} sx={{ maxWidth: "900px", mx: "auto" }}>
//                 {listData.map((p, i) => (
//                     <Box key={p.id}>
//                         <BlogListItem
//                             href={p.href}
//                             imageSrc={p.image_url}
//                             category={p.category}
//                             title={p.title}
//                             excerpt={p.excerpt}
//                             author={p.author}
//                             date={p.date}
//                             profileImage={p.profileImage}
//                         />
//                         {i < listData.length - 1 && <Divider sx={{ mt: 4 }} />}
//                     </Box>
//                 ))}
//             </Stack>
//         </Box>
//     );
// }


import React from "react";
import { Box, Stack, Divider, CircularProgress } from "@mui/material";
import BlogListItem from "./BlogList";
import { useRouter } from 'next/router'
import Heading from "../../heading";


export default function RoiInvestorBenefits({ data = [], pageName, bgcolor }) {
  const [loading, setLoading] = React.useState(false);

  const router = useRouter()
  const isActivityPage =
    router.asPath.includes("activities") ||
    router.query.activities !== undefined;

  const isPackagesPage =
    router.asPath.includes("?packages") ||
    router.query.activities !== undefined;

  // console.log("isActivityPage",isActivityPage);

  const listData = Array.isArray(data)
    ? data.map((item) => {
      const baseHref = `/blogs/${item?.slug || item?._id}`;
      const href = isActivityPage
        ? `${baseHref}?activities` :
        isPackagesPage
          ? `${baseHref}?packages`
          : baseHref;

      return {
        id: item._id,
        href,
        imageSrc: `${process.env.IMAGE_BASE_URL}/${item.image_url}`,
        category: item.tags?.[0] ?? "BLOG",
        title: item.title,
        excerpt: item.sub_title,
        author: item.posted_by_name,
        date: item.posted_at_formated,
        profileImage: item.posted_by_profile_image,
      };
    })
    : [];


  return (
    <Box
      component="section"
      sx={{
        py: { xs: 8, md: 4 },
        px: { xs: 2, sm: 3 },
        bgcolor: bgcolor ?? "#ffffff",
      }}
    >
      {/* Loader (optional) */}

      {!isActivityPage &&
        <Heading title="Explore our categories" subtitle="Make journey comfortable with" />
      }
      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", py: 5 }}>
          <CircularProgress />
        </Box>
      ) : (
        <Stack spacing={5} sx={{ maxWidth: "1000px", mx: "auto" }}>
          {listData.map((p, i) => (
            <Box key={p.id}>
              <BlogListItem
                href={p.href}
                imageSrc={p.imageSrc}
                category={p.category}
                title={p.title}
                excerpt={p.excerpt}
                author={p.author}
                date={p.date}
                profileImage={p.profileImage}
              />
              {i < listData.length - 1 && <Divider sx={{ mt: 4 }} />}
            </Box>
          ))}
        </Stack>
      )}
    </Box>
  );
}



